import ArrowLeftOutlined from "@ant-design/icons/ArrowLeftOutlined";
import SearchOutlined from "@ant-design/icons/SearchOutlined";
import React, { useContext, useEffect } from "react";
import { PageWrapperContext } from "common/Home/PageWrapper.context";
import useInput from "utils/hooks/useInput";
import Input from "common/Inputs/Input.js";
import { useHistory, useLocation } from "react-router-dom";
import { HEADER_ICON_SIZE } from "@shared/common/Themes/constants";
import styled, { useTheme } from "styled-components";
import { useBottomNavigator } from "utils/hooks/misc.tsx";

interface MobileSearchProps {
  searchOpen: boolean;
  setSearchOpen: (searchOpen: boolean) => void;
}

const MobileSearch = ({ searchOpen, setSearchOpen }: MobileSearchProps) => {
  const theme = useTheme();
  const { search, setSearchValue } = useContext(PageWrapperContext);
  const { setValue, bind, ref } = useInput("", setSearchValue, null);
  const history = useHistory();
  const location = useLocation();
  const { baseShouldDisplay: isBottomNavigator } = useBottomNavigator();

  useEffect(() => {
    if (searchOpen) {
      ref?.current?.focus();
    }
  }, [searchOpen]);

  const clearSearch = () => {
    setSearchOpen(false);
    setSearchValue("");
    setValue("");
  };

  useEffect(() => {
    const unblock = history.block((nextLocation) => {
      const closeSearch =
        searchOpen && !nextLocation.pathname.startsWith(location.pathname);
      if (closeSearch) {
        clearSearch();
      }
    });

    return () => {
      unblock();
    };
  }, [searchOpen]);

  if (!search.show) return null;

  return (
    <>
      {!searchOpen ? (
        <SearchOutlined
          style={{
            fontSize: HEADER_ICON_SIZE,
            marginLeft: isBottomNavigator ? 4 : 12,
          }}
          onClick={() => setSearchOpen(!searchOpen)}
        />
      ) : (
        <>
          <ArrowLeftOutlined
            style={{ cursor: "pointer" }}
            onClick={clearSearch}
          />
          <StyledInput
            ref={ref}
            bordered={false}
            placeholder="Search..."
            $bgColor={theme.colors.layoutBgColor}
            {...bind}
          />
        </>
      )}
    </>
  );
};

export default MobileSearch;

const StyledInput = styled(Input)`
  border: none !important;
  width: 100%;
  max-width: 100%;
  flex: 1;
`;
